import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesTransactions } from "../../constants";
import { TransactionItem } from "../../financial.types";

export const requestTransactionById = async (
  id: string
): Promise<TransactionItem> => {
  return await instance.get(buildUrl(ApiRoutesTransactions.Transactions, id));
};
